var __rspack_ns_object = JSON.parse('{"dismiss":{"id":"snackbarProvider.dismiss","defaultMessage":"Dismiss"}}')